import { Field, ErrorMessage } from "formik";
import { JsonEditor } from "json-edit-react";

const FormJsonEditor = ({
  label = "JSON Editor",
  labelClassName = "",
  name = "jsonField",
  className = "",
  required = false,
  value = "",
  ...props
}) => {
  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, form, meta }) => {
          const handleChange = (updatedJson) => {
            form.setFieldValue(name, updatedJson);
          };

          return (
            <div className={`flex flex-col gap-1 ${className}`}>
              {label && (
                <label
                  htmlFor={name}
                  className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                    meta.touched && meta.error
                      ? "text-errorColor"
                      : labelClassName
                  }`}
                >
                  {label} {required && <span className="text-red-500">*</span>}
                </label>
              )}

              <div
                className={`border rounded-lg overflow-auto ${
                  meta.touched && meta.error
                    ? "border-errorColor"
                    : "border-greyText"
                }`}
              >
                <JsonEditor data={value} onChange={handleChange} {...props} />
              </div>

              <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                <ErrorMessage name={name} />
              </label>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default FormJsonEditor;
